<template>
	<div class="dashboard-chart-card mr-1">
		<div class="d-flex justify-content-center mb-3 mt-3 pt-3 pb-3" v-if="is_load">
			<b-spinner variant="success" label="Loading..."></b-spinner>
		</div>

		<div class="chart" v-else>
			<highcharts :options="chartOptions" :highcharts="char3d"></highcharts>
		</div>
	</div>
</template>

<script>
import {Chart} from 'highcharts-vue';
import Highcharts3D from 'highcharts/highcharts-3d';
import Highcharts from 'highcharts';

Highcharts3D(Highcharts);
export default {
	name: "month_pay",

	props: {
		id: {
			type: Number,
			require: false,
		},

		cur_type  : {
			type: String,
			default:"counts"
		},

		month: {
			type: String,
			default:""
		},

	},

	components: {
		highcharts: Chart
	},


	created () {
		EventBus.$on('change_date',res => {
			this.getStat();
		}) ;
	},

	mounted() {
		this.getStat();
	},

	data() {
		return {
			is_load: true,
			char3d : Highcharts,
			chartOptions: {
				chart: {
					lang: {
						loading: 'Загрузка...',
						shortMonths: ['янв', 'фев', 'мар', 'апр', 'май', 'июн', 'июл', 'авг', 'сен', 'окт', 'ноя', 'дек'],
					},
					options3d: {
						enabled: true,
						alpha: 16,
						beta: 0,
						depth: 68
					}
					// plotBackgroundImage: '/components/com_sp/images/plot.png'
				},

				title:
					{
						text: this.__t('CUR_MONTH'),
						align: 'left',
						style:
							{
								color: '#3b3f5c',
								fontSize: '15px',
								fontWeight: '600',
							}
						//x: -20 //center
					},
				subtitle:
					{
						//text: 'Source',
						//x: -20
					},
				xAxis:
					{
						type: 'datetime',
						lineColor: '#eef0f5',
						dateTimeLabelFormats: {
							day: '%e %b',
							week: '%e %b',
						}
					},
				yAxis: {
					title: {
						text: null
					},
					gridLineColor: '#f1f2f7',
					plotLines: [{
						value: 0,
						width: 1,
						color: '#5ea214'
					}]
				},
				tooltip: {
					valueSuffix: '$',
					xDateFormat: '%d/%m/%Y',
					pointFormat: "{point.y:,.1f} $"
				},
				legend: {
					layout: 'vertical',
					align: 'right',
					verticalAlign: 'middle',
					borderWidth: 0
				},
				credits: {
					enabled: false
				},
				series: [{
					name: 'Банк',
					showInLegend: false,

					zones: [{
						value: 0,
						color: '#DC3545'
					}, {
						value: 200,
						color: '#DC3545'
					},
						{
							color: '#28a745'
						}],
					data: []
				},{
					name : "Оплата",
					showInLegend: false,
					data: [],
				}]

			},
		}
	},


	methods: {
		async getStat() {
			this.is_load = true;

			await api.post('/internal/user/dashboard/bank', qs.stringify({
					'stat_type':'month_pay',
					'date' : this.dash_param_date,
				})

			).then(({data}) => {

				if (data.status == "operation_success") {
					this.chartOptions.series[0].data = data.data.series;
					this.chartOptions.series[1].data = data.data.series_pay;
					this.is_load = false;
				}

			}).catch(err => {
				this.is_load = true;
				console.log(err);
				EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name})
			});
		},

	},
	computed: {

		dash_param_date() {
			return this.$store.state.dashboard.main.date;
		},

	},

}
</script>

<style scoped>

</style>
